"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const merge_1 = __importDefault(require("lodash/merge"));
const _contracts_1 = require("../_contracts");
const abstract_module_1 = require("./abstract-module");
/**
 * The abstract class that every module's form **HAS TO** extend.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let AbstractModuleForm = class AbstractModuleForm extends abstract_module_1.AbstractModule {
    constructor() {
        super(...arguments);
        /**
         * Record of related attached to form.
         */
        this.descriptions = {};
        /**
         * TODO: Description.
         */
        this.initialContent = null;
    }
    /**
     * Determines whether the given module works in the `default` mode.
     */
    get isDefaultMode() {
        return this.mode === _contracts_1.ModuleMode.Default;
    }
    /**
     * Determines whether the given module works in the `layout` mode.
     */
    get isLayoutMode() {
        return this.mode === _contracts_1.ModuleMode.Layout;
    }
    /**
     * Determines whether the given module works in the `smart` mode.
     */
    get isSmartMode() {
        return this.mode === _contracts_1.ModuleMode.Smart;
    }
    /**
     * Complete corrputed header
     * Call in created Hook
     */
    completeHeader(tempContent) {
        if (!Object.prototype.hasOwnProperty.call(tempContent, 'header')) {
            return;
        }
        if (tempContent.header && !Object.prototype.hasOwnProperty.call(tempContent.header, 'text')) {
            tempContent.header.text = '';
        }
        if (tempContent.header && !Object.prototype.hasOwnProperty.call(tempContent.header, 'site')) {
            tempContent.header.site = '';
        }
    }
    describe(related, keyName = 'title', fallback = 'Nie można znaleźć opisu') {
        if (!this.descriptions[related.type]) {
            this.descriptions[related.type] = {};
        }
        this.relatedService.describe(related).then((list) => {
            this.descriptions[related.type][related.value] = list[keyName] || 'Nie znaleziono klucza';
        }).catch((error) => {
            this.descriptions[related.type][related.value] = fallback;
            console.warn(error);
        }).finally(() => {
            this.$forceUpdate();
        });
    }
    /**
     * Resolves the description of the given related data.
     *
     * @param related
     */
    description(related) {
        if (!this.descriptions[related.type]) {
            return '';
        }
        return this.descriptions[related.type][related.value] || '';
    }
    /**
     * Called just after the `setInitialContent()` method.
     */
    afterInitialContentSetup() {
        //
    }
    /**
     * Called just before the `setInitialContent()` method.
     */
    beforeInitialContentSetup() {
        //
    }
    /**
     * Merges `this.initialContent` with the current value of `this._content`.
     */
    setInitialContent() {
        if (this.initialContent === null) {
            throw new Error('AbstractModuleForm.setInitialContent(): [this.initialContent] is [null], but its value should be set from/inside the subclass!');
        }
        this._content = merge_1.default(this.initialContent, this._content);
    }
    get isCustomColor() {
        return this._content.backgroundColor === _contracts_1.ModuleBackgroundColor.Custom;
    }
    get backgroundColorOptions() {
        return Object.values(_contracts_1.ModuleBackgroundColor)
            .map(value => ({
            label: this.$t(`modules.backgroundColors.${value}`),
            value: value
        }));
    }
};
__decorate([
    vue_property_decorator_1.PropSync('content', { type: Object, required: true }),
    __metadata("design:type", Object)
], AbstractModuleForm.prototype, "_content", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], AbstractModuleForm.prototype, "disabled", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Array, required: false, default: () => [] }),
    __metadata("design:type", Array)
], AbstractModuleForm.prototype, "errors", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false, default: _contracts_1.ModuleMode.Default }),
    __metadata("design:type", String)
], AbstractModuleForm.prototype, "mode", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], AbstractModuleForm.prototype, "pickRelated", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: false }),
    __metadata("design:type", Object)
], AbstractModuleForm.prototype, "size", void 0);
__decorate([
    vue_property_decorator_1.PropSync('version', { type: String, required: false }),
    __metadata("design:type", Object)
], AbstractModuleForm.prototype, "_version", void 0);
AbstractModuleForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'AbstractModuleForm',
        created() {
            this.beforeInitialContentSetup();
            this.setInitialContent();
            this.afterInitialContentSetup();
        }
    })
], AbstractModuleForm);
exports.AbstractModuleForm = AbstractModuleForm;
//# sourceMappingURL=abstract-module.form.js.map